import { SCRIP_SEARCH, SET_ARR_SCRIPS_TO_BE_ADDED } from "../actionTypes";

const initialState = {
    totalScrips: 0, //Init 20 for first search call
    prevCount: 0,
    searchAllScrips: { data: [], count: 0 },
    searchEqScrips: { data: [], count: 0 },
    searchFutScrips: { data: [], count: 0 },
    searchOptScrips: { data: [], count: 0 },
    searchMFScrips: { data: [], count: 0 },
    searchPages: { data: [], count: 0 },
    arrTotalPages: [],
    isLoading: true,
    arrFilteredRecommendations: { data: [], count: 0 },
    arrFilteredAlerts: { data: [], count: 0 },
    arrFilteredEvents: { data: [], count: 0 },
    arrFilteredNews: { data: [], count: 0 },
    arrFilteredIPO: { data: [], count: 0 },
    objSearchScripDataStatus: { status: true, strNoDataMessage: '' },
    objSearchMFScripDataStatus: { status: true, strNoDataMessage: '' },
    arrRecentlySearchScrips: [],
    arrTrending: [],
    // BT-118877 : Functional Implementation - Global Search : Vinit R : 09/10/2023 - Start 
    arrRecentlySearchMFScrips: [],
    // BT-118877 : Functional Implementation - Global Search : Vinit R : 09/10/2023 - End 
    arrScripsToBeAdded: [],
    objGlobalAddScripWatchlist : {}
};

const globalSearchReducer = (state = initialState, actions) => {
    switch (actions.type) {
        case SCRIP_SEARCH.IS_LOADING: {
            return {
                ...state,
                isLoading: actions.payload,
            };
        }
        case SCRIP_SEARCH.GET_SEARCH_ALL_SCRIPS_SUCCESS: {
            return {
                ...state,
                searchAllScrips: actions.payload,
            };
        }
        case SCRIP_SEARCH.GET_SEARCH_ALL_SCRIPS_FAILURE: {
            return {
                ...state,
                searchAllScrips: actions.payload
            };
        }
        case SCRIP_SEARCH.GET_SEARCH_EQ_SCRIPS_SUCCESS: {
            return {
                ...state,
                searchEqScrips: actions.payload,
            };
        }
        case SCRIP_SEARCH.GET_SEARCH_EQ_SCRIPS_FAILURE: {
            return {
                ...state,
                searchEqScrips: actions.payload
            };
        }

        case SCRIP_SEARCH.GET_SEARCH_MF_SCRIPS_SUCCESS: {
            return {
                ...state,
                searchMFScrips: actions.payload,
            };
        }
        case SCRIP_SEARCH.GET_SEARCH_MF_SCRIPS_FAILURE: {
            return {
                ...state,
                searchMFScrips: actions.payload
            };
        }

        case SCRIP_SEARCH.GET_SEARCH_FUT_SCRIPS_SUCCESS: {
            return {
                ...state,
                searchFutScrips: actions.payload,
            };
        }
        case SCRIP_SEARCH.GET_SEARCH_FUT_SCRIPS_FAILURE: {
            return {
                ...state,
                searchFutScrips: actions.payload
            };
        }
        case SCRIP_SEARCH.GET_SEARCH_OPT_SCRIPS_SUCCESS: {
            return {
                ...state,
                searchOptScrips: actions.payload,
            };
        }
        case SCRIP_SEARCH.GET_SEARCH_OPT_SCRIPS_FAILURE: {
            return {
                ...state,
                searchOptScrips: actions.payload
            };
        }
        case SCRIP_SEARCH.UPDATE_SEARCH_PAGES: {
            return {
                ...state,
                searchPages: actions.payload
            };
        }
        case SCRIP_SEARCH.RECENT_SEARCH_SCRIPS: {
            return {
                ...state,
                arrRecentlySearchScrips: actions.payload
            };
        }
        case SCRIP_SEARCH.TRENDING_SEARCH_SCRIPS: {
            return {
                ...state,
                arrTrending: actions.payload
            };
        }

        // BT-118877 : Functional Implementation - Global Search : Vinit R : 09/10/2023 - Start 
        case SCRIP_SEARCH.RECENT_SEARCH_MF_SCRIPS: {
            return {
                ...state,
                arrRecentlySearchMFScrips: actions.payload
            };
        }
        // BT-118877 : Functional Implementation - Global Search : Vinit R : 09/10/2023 - End

        case SCRIP_SEARCH.GET_SEARCH_RECOMMENDATION_SCRIPS_SUCCESS: {
            return {
                ...state,
                arrFilteredRecommendations: actions.payload
            };
        }
        case SCRIP_SEARCH.GET_SEARCH_RECOMMENDATION_SCRIPS_FAILURE: {
            return {
                ...state,
                arrFilteredRecommendations: actions.payload
            };
        }
        case SCRIP_SEARCH.GET_SEARCH_ALERT_SCRIPS_SUCCESS: {
            return {
                ...state,
                arrFilteredAlerts: actions.payload
            };
        }
        case SCRIP_SEARCH.GET_SEARCH_ALERT_SCRIPS_FAILURE: {
            return {
                ...state,
                arrFilteredAlerts: actions.payload
            };
        }
        case SCRIP_SEARCH.GET_SEARCH_EVENT_SCRIPS_SUCCESS: {
            return {
                ...state,
                arrFilteredEvents: actions.payload
            };
        }
        case SCRIP_SEARCH.GET_SEARCH_EVENT_SCRIPS_FAILURE: {
            return {
                ...state,
                arrFilteredEvents: actions.payload
            };
        }
        case SCRIP_SEARCH.GET_SEARCH_IPO_SCRIPS_SUCCESS: {
            return {
                ...state,
                arrFilteredIPO: actions.payload
            };
        }
        case SCRIP_SEARCH.GET_SEARCH_IPO_SCRIPS_FAILURE: {
            return {
                ...state,
                arrFilteredIPO: actions.payload
            };
        }
        case SCRIP_SEARCH.GET_SEARCH_NEWS_SCRIPS_SUCCESS: {
            return {
                ...state,
                arrFilteredNews: actions.payload
            };
        }
        case SCRIP_SEARCH.GET_SEARCH_NEWS_SCRIPS_FAILURE: {
            return {
                ...state,
                arrFilteredNews: actions.payload
            };
        }
        case SCRIP_SEARCH.UPDATE_SEARCH_SCRIP_DATA_STATUS_SUCCESS: {
            return {
                ...state,
                objSearchScripDataStatus: actions.payload
            };
        }
        case SCRIP_SEARCH.UPDATE_SEARCH_SCRIP_DATA_STATUS_FAILURE: {
            return {
                ...state,
                objSearchScripDataStatus: actions.payload
            };
        }

            // {/* BT-118877 : Functional Implementation - Global Search : Vinit R : 09/10/2023 - Start */ }
        case SCRIP_SEARCH.UPDATE_SEARCH_MF_SCRIP_DATA_STATUS_SUCCESS: {
            return {
                ...state,
                objSearchMFScripDataStatus: actions.payload
            };
        }
        case SCRIP_SEARCH.UPDATE_SEARCH_MF_SCRIP_DATA_STATUS_FAILURE: {
            return {
                ...state,
                objSearchMFScripDataStatus: actions.payload
            };
        }
            // {/* BT-118877 : Functional Implementation - Global Search : Vinit R : 09/10/2023 - End */ }

        case SCRIP_SEARCH.UPDATE_TOTAL_PAGES: {
            return {
                ...state,
                arrTotalPages: actions.payload
            };
        }
        case SET_ARR_SCRIPS_TO_BE_ADDED: {
            return {
                ...state,
                arrScripsToBeAdded: actions.payload
            };
        }
        case SCRIP_SEARCH.UPDATE_GLOBAL_ADDSCRIP_WATCHLIST : {
            return {
                ...state,
                objGlobalAddScripWatchlist: actions.payload
            };
        }
        default:
            return state;
    }

};

export default globalSearchReducer;